import z from "zod";

import { zSpecAccess } from "./ZSpecAccess";

export const zObjectAccess = z.object({
  views: zSpecAccess.array(),
});

export type ZObjectAccess = z.infer<typeof zObjectAccess>;

export const zObjectPermissions = z.object({
  canDelete: z.boolean().optional(),
  canUpdate: z.boolean().optional(),
});
export type ZObjectPermissions = z.infer<typeof zObjectPermissions>;
